import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import styles from "./Edufin.module.css";
import NewFormTextInput from "../../../../../components/FormTextInput/NewFormTextInput";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";

const EdufinIntegrateModal = ({ open, setOpen }: any) => {
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        // fullWidth
        maxWidth="lg"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Integrate Edufin
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <div className={styles.instutueDetailsBoxForModal}>
            <div className={styles.groupingBoxForModal}>
              <div style={{ width: "400px" }}>
                <NewFormTextInput
                  validate={true}
                  label="Institute Name"
                  type="text"
                  id={"instituteName"}
                  placeholder="eg: React learning Hub"
                  inputProps={{
                    maxLength: 100,
                  }}
                  require={true}
                />
              </div>
              <div style={{ width: "400px" }}>
                <AutoCompleteField
                  id="branchId"
                  label="Branch"
                  options={[]}
                  optionLabel={"branchName"}
                  required={true}
                />
              </div>
            </div>
            <div className={styles.groupingBoxForModal}>
              <div style={{ width: "400px" }}>
                <NewFormTextInput
                  validate={true}
                  label="Bank Name"
                  type="text"
                  id={"instituteName"}
                  placeholder="eg: React learning Hub"
                  inputProps={{
                    maxLength: 100,
                  }}
                  require={true}
                />
              </div>
              <div style={{ width: "400px" }}>
                <NewFormTextInput
                  validate={true}
                  label="Bank Account No"
                  type="text"
                  id={"instituteName"}
                  placeholder="eg: React learning Hub"
                  inputProps={{
                    maxLength: 100,
                  }}
                  require={true}
                />
              </div>
            </div>
            <div
              // className={styles.groupingBoxForModal}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "400px",
                }}
              >
                <NewFormTextInput
                  validate={true}
                  label="Edufin Id"
                  type="text"
                  id={"instituteName"}
                  placeholder="eg: React learning Hub"
                  inputProps={{
                    maxLength: 100,
                  }}
                  require={true}
                />
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default EdufinIntegrateModal;
